import { AlarmTypes } from "../../local_modules/voyage-vessel-alarm-popup/src/type";
import { NotificationTypes, VoyNotification } from "../services/types/vessel-notifications-services.types";

export const getAlarmDescription = (
	alarm: VoyNotification<NotificationTypes.Alarm>
): { alarmDesc: string; alarmsubDesc: string } => {
	
	let alarmData = alarm?.data;
	const type = alarmData.alarmType?.toLocaleLowerCase();

	let alarmDesc: string;
	let alarmsubDesc: string;
	
	switch (type) {
		case AlarmTypes.Stoppage:
			alarmDesc = `The vessel has been below 6 kt for more than 1 hour`;
			alarmsubDesc = `Select reason for stoppage`;
			break;

		case AlarmTypes.Speed:
			alarmDesc = `The vessel is deviating from the planned speed by +/- 1.5 kt for more than 2 hours`;
			alarmsubDesc = `Select reason for speed deviation`;
			break;

		case AlarmTypes.Crosstrack:
			alarmDesc = `The vessel is deviating for more than 10 NM from the course line`;
			alarmsubDesc = `Select reason for offtrack`;
			break;

		default:
			alarmDesc = `The vessel is deviating for more than - NM from the course line`;
			alarmsubDesc = `Select reason for alarm`;
	}
	return {
		alarmDesc,
		alarmsubDesc,
	};
};


export const getTitleForWniReportNotification = (notification: any) => {
	return `WNI Report Notification`;
}
